module.exports = __webpack_public_path__ + "img/ChristianAcosta.50b2916b.png";